// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__GJ10U","cardSearch":"card_cardSearch__ebeGY","hoverable":"card_hoverable__gOGtL","bordered":"card_bordered__PoWhW","noShadowBorder":"card_noShadowBorder__49ac9"};